(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daliali-home-unified"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('daliali-home-unified')) {
  customElements.define('daliali-home-unified', class extends HTMLElement {
    connectedCallback() {
      this.mountFrame = requestAnimationFrame(() => {
        if (this.isConnected) this.mount();
      });
    }
    mount() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.du-home__track');
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.buttons = Array.from(this.querySelectorAll('[data-select]'));
      if (!this.track || !this.panels.length) return;
      this.current = 0;
      this.lastWidth = 0;
      this.setHeight = () => {
        const panel = this.panels[this.current];
        if (panel) this.track.style.height = `${Math.ceil(panel.getBoundingClientRect().height)}px`;
      };
      this.select = (index, instant = false) => {
        const target = this.panels[index];
        if (!target) return;
        target.inert = false;
        target.removeAttribute('aria-hidden');
        const offset = target.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: offset, behavior: instant || reduced ? 'instant' : 'smooth' });
      };
      this.update = () => {
        const left = this.track.getBoundingClientRect().left;
        let nearest = 0;
        let distance = Infinity;
        this.panels.forEach((panel, index) => {
          const delta = Math.abs(panel.getBoundingClientRect().left - left);
          if (delta < distance) { nearest = index; distance = delta; }
        });
        this.current = nearest;
        this.buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === nearest)));
        this.panels.forEach((panel, index) => {
          const active = index === nearest;
          panel.inert = !active;
          if (active) panel.removeAttribute('aria-hidden');
          else panel.setAttribute('aria-hidden', 'true');
        });
        this.setHeight();
      };
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.select(index), options);
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.panels.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.panels.length) % this.panels.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.panels.length - 1;
          else return;
          event.preventDefault();
          this.buttons[next].focus();
          this.select(next);
        }, options);
      });
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.select((this.current - 1 + this.panels.length) % this.panels.length), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.select((this.current + 1) % this.panels.length), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.update);
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.panels.length - 1 : (this.current + (event.key === 'ArrowRight' ? 1 : -1) + this.panels.length) % this.panels.length;
        this.select(next);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index, true);
      }, options);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => {
          const width = this.track.clientWidth;
          if (width !== this.lastWidth) { this.lastWidth = width; this.select(this.current, true); }
          this.setHeight();
        });
        this.observer.observe(this.track);
        this.panels.forEach(panel => this.observer.observe(panel));
      }
      const controls = this.querySelector('[data-controls]');
      if (controls) controls.hidden = false;
      this.update();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.mountFrame);
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-404-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-smart-404]');
  if (!root) return;

  let path = '';

  try {
    path = decodeURIComponent(window.location.pathname).toLowerCase();
  } catch (e) {
    path = window.location.pathname.toLowerCase();
  }

  let handle = 'tout';
  let title = 'Découvrez nos produits';
  let text = 'Voici une sélection pour poursuivre votre visite.';

  const hasAny = (terms) => terms.some((term) => path.includes(term));

  if (hasAny(['vie-intense', 'collection-privee', 'collection-privée'])) {
    handle = 'collection-daliali';
    title = 'Découvrez la Collection Daliali';
    text = 'Le produit recherché n’est plus disponible. Voici des parfums de notre collection susceptibles de vous plaire.';
  } else if (hasAny(['kailoa', 'botox', 'lissage', 'capillaire'])) {
    handle = 'kailoa';
    title = 'Découvrez nos soins Kaïloa';
    text = 'Le produit recherché n’est plus disponible. Voici une sélection de soins capillaires proches.';
  } else if (hasAny(['brume', 'body-mist', 'bodymist'])) {
    handle = 'brumes';
    title = 'Découvrez nos brumes parfumées';
    text = 'Le produit recherché n’est plus disponible. Voici des brumes proches de votre recherche.';
  } else if (hasAny(['lattafa', 'dubai', 'dubaï', 'musc', 'parfum', 'eau-de-parfum'])) {
    handle = 'parfums';
    title = 'Découvrez nos parfums';
    text = 'Le produit recherché n’est plus disponible. Voici une sélection de parfums à découvrir.';
  }

  const target =
    root.querySelector('[data-smart-404-group="' + handle + '"]') ||
    root.querySelector('[data-smart-404-group="tout"]');

  if (target) {
    target.hidden = false;
  }

  const heading = root.querySelector('[data-smart-404-title]');
  const paragraph = root.querySelector('[data-smart-404-text]');
  const link = root.querySelector('[data-smart-404-link]');

  if (heading) {
    heading.textContent = title;
  }

  if (paragraph) {
    paragraph.textContent = text;
  }

  if (link) {
    link.href =
      (window.Shopify?.routes?.root || '/') +
      'collections/' +
      handle;

    link.textContent =
      handle === 'tout'
        ? 'Parcourir la boutique'
        : 'Voir toute la sélection';
  }
})();

  } catch(e) { console.error(e); }
})();
})();
